import { boolean, number, object, SchemaOf, string } from 'yup';

import { edgeAsyncIntervalsValidation } from '@/react/edge/components/EdgeAsyncIntervalsForm';
import { validation as urlValidation } from '@/react/portainer/common/PortainerUrlField';
import { validation as addressValidation } from '@/react/portainer/common/PortainerTunnelAddrField';
import { metadataValidation } from '@/react/portainer/environments/common/MetadataFieldset/validation';

import { formatErrors, parseMachines } from './parseMachines';
import { FormValues } from './types';

export function validationSchema(asyncMode: boolean): SchemaOf<FormValues> {
  return object().shape({
    credentialId: number().required('An SSH credential is required'),
    machines: string()
      .required('At least one machine is required')
      .test('machines', '', (value, context) => {
        const { errors } = parseMachines(value ?? '');
        return (
          errors.length === 0 ||
          context.createError({ message: formatErrors(errors) })
        );
      }),
    kubesoloVersion: string().default(''),
    offline: boolean().required(),
    portainerUrl: urlValidation(),
    tunnelServerAddr: asyncMode ? string() : addressValidation(),
    pollFrequency: number().required(),
    meta: metadataValidation(),
    edge: edgeAsyncIntervalsValidation(),
  });
}
